import { APIValidationError } from '../api/api';

const errorMessage = (e: any): string => {
  if (e instanceof APIValidationError) {
    return e.fields.map(col => col.message).join(' - ');
  }
  if (e instanceof Error) return e.message;
  return 'Error desconocido';
};

export default errorMessage;
